import React, { Component } from 'react';
import { Row } from 'reactstrap';

import AppRoutes from '../../../views/config/AppRoutes';
import LoaderWrapper from '../LoaderWrapper';
import List from './List';
import {
  fetchQuestionsChapterWise,
  getTokenAndEmail,
  fetchChapterNameById,
  pdfDownloadViaEmail,
} from '../services';
import Header from '../Header';
import language from '../../../assets/languages/language';
import CustomButton from '../Button/CustomButton';
import alertMessage from '../../config/alertMessage';
import ModalComponent from '../../Common/Modal';
import PDFModelComponent from '../../Common/PDFModel';
import { examNameAccordingToDB } from '../../../common/constant';
import { fetchFreeUseSubscriptionMessage } from '../../../services/exams';

export default class QuestionsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      questionStatsTableName: '',
      isLoading: true,
      chapterName: '',
      userSubscriptionDetails: {},
      subscriptionMessage: alertMessage.messageContent_ESG,
      contentHeader: 'Subscribe for 3,000 practice questions',
      pdfAlert: false,
      PDFDownloadType: 'Question',
    };
  }
  componentDidMount = async () => {
    window.scrollTo(0, 0);
    const { listId: chapterId } = this.props.params;
    const data = {
      ...getTokenAndEmail(),
      chapterId,
    };

    this.setContentMessage();

    fetchQuestionsChapterWise(data).then(response => {
      if (response.success) {
        const { questionStatsTableName, question: listData, userSubscriptionDetails } = response;
        this.setState({
          listData,
          questionStatsTableName: questionStatsTableName || 'esg_question_stats',
          userSubscriptionDetails,
        });
      }
      this.setState({ isLoading: false });
    });

    fetchChapterNameById(data).then(response => {
      if (response.success) {
        const { name } = response.chapter;
        this.setState({ chapterName: name });
      }
    });
  };

  static contextTypes = { router: React.PropTypes.object };

  setContentMessage = async () => {
    const result = await fetchFreeUseSubscriptionMessage({
      exam: 'esg',
      section: 'question',
    });
    if (result.success) {
      const { html_content, header } = result.data;
      this.setState({
        subscriptionMessage: html_content,
        contentHeader: header,
      });
    }
  };

  redirectToQuestion = data => {
    const { listId, id, offset } = data;
    this.context.router.push({
      pathname: AppRoutes.ESG_QUESTION_BANK_VIEW_QUE.replace(':chapterId', listId)
        .replace(':index', offset)
        .replace(':id', id),
    });
  };

  goPremium = () => {
    this.context.router.push({ pathname: '/Subscribe/' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };

  checkSubscription = async (cb, type) => {
    const { userSubscriptionDetails } = this.state;
    if (!Object.keys(userSubscriptionDetails).length)
      return this.setState({ openPremiumPopup: true });
    cb();
    this.setState({ PDFDownloadType: type });
    this.pdfAlertModel();
  };

  pdfAlertModel = () => {
    this.setState({ pdfAlert: !this.state.pdfAlert });
  };

  render() {
    const {
      listData,
      questionStatsTableName,
      chapterName,
      isLoading,
      userSubscriptionDetails,
      openPremiumPopup,
      subscriptionMessage,
      contentHeader,
    } = this.state;
    const { listId } = this.props.params;

    return (
      <div className='animated fadeIn'>
        <Header title={language.LC().QUESTION_BANK}>
          <div>
            <CustomButton
              className={'bg-completed-cases overflow-hidden max-width-min-content'}
              onClick={() => {
                this.checkSubscription(
                  () => pdfDownloadViaEmail({ type: 'question', chapterNo: listId }),
                  'Question',
                );
              }}
            >
              <i className='fa fa-download' aria-hidden='true' />{' '}
              {!Object.keys(userSubscriptionDetails).length && (
                <div className='premium-download'>Premium</div>
              )}
              {language.LC().Download_Question}
            </CustomButton>
            <CustomButton
              className={'bg-completed-cases overflow-hidden max-width-min-content'}
              onClick={() => {
                this.checkSubscription(
                  () => pdfDownloadViaEmail({ type: 'questionAnswer', chapterNo: listId }),
                  'Question/Answer',
                );
              }}
            >
              <i className='fa fa-download ' aria-hidden='true' />{' '}
              {!Object.keys(userSubscriptionDetails).length && (
                <div className='premium-download'>Premium</div>
              )}
              {language.LC().Download_Question_Answer}{' '}
            </CustomButton>
            <CustomButton
              onClick={() => this.context.router.push({ pathname: AppRoutes.ESG_QUESTION_BANK })}
            >
              {' '}
              {language.LC().CHANGE_TOPIC}{' '}
            </CustomButton>
          </div>
        </Header>
        <LoaderWrapper isLoading={isLoading}>
          <Row>
            {listData.map((item, index) => {
              return (
                <List
                  headerIcon={'/img/question_bank/question_icon-blu.svg'}
                  headerContent={`${chapterName} (Q. ${item.id})`}
                  bodyContent={item.question}
                  key={item.id}
                  onClick={() =>
                    this.redirectToQuestion({
                      offset: index,
                      listId,
                      id: item.id,
                    })
                  }
                >
                  {item[questionStatsTableName].length ? (
                    <div id='answered_status'>Answered</div>
                  ) : (
                    <div id='notanswered_status'>Not Answered </div>
                  )}
                </List>
              );
            })}

            {!Object.keys(userSubscriptionDetails).length && (
              <List
                headerIcon='/img/question_bank/question_icon-blu.svg'
                headerContent={contentHeader}
                bodyContent={subscriptionMessage}
                paddingBox={'padding_box_free'}
              >
                <CustomButton
                  className='text-center d-block mx-auto'
                  onClick={() => this.context.router.push({ pathname: AppRoutes.SUBSCRIBE })}
                >
                  Subscribe
                </CustomButton>
              </List>
            )}
          </Row>
        </LoaderWrapper>
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_ESG}
          exam={examNameAccordingToDB.ESG}
        />
        <PDFModelComponent
          type={this.state.PDFDownloadType}
          pdfAlertModel={this.pdfAlertModel}
          pdfAlert={this.state.pdfAlert}
          PDFContentMessage={language.LC().PDFContentMessage}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/QuestionList.jsx